import { HttpError } from './http.error';

export class NotFoundError extends HttpError {
  constructor(message?: string) {
    super(404, message);
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/not-found.error.ts